"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentItemFieldKey_1 = require("./getContentItemFieldKey");
exports.getContentItemFieldData = (ci, key, defaultValue) => {
    const val = getContentItemFieldKey_1.getContentItemFieldKey(ci, key, 'data');
    const hasVal = typeof val === 'undefined'
        ? null
        : typeof val === 'string'
            ? !!val.trim()
            : false;
    const newVal = val || defaultValue;
    return [typeof newVal === 'string' ? newVal.trim() : defaultValue, hasVal];
};
//# sourceMappingURL=getContentItemFieldData.js.map